var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoReportFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 33H35.9992V15H44.9992L29.9992 0L14.9992 15H23.9992V33ZM58.0132 37.596C57.3832 36.924 53.1802 32.427 51.9802 31.254C51.1393 30.4479 50.0191 29.9985 48.8542 30H43.5832L52.7752 38.982H42.1432C41.9987 38.9793 41.8561 39.0148 41.7297 39.0849C41.6033 39.1549 41.4976 39.2571 41.4232 39.381L38.9752 45H21.0232L18.5752 39.381C18.5004 39.2575 18.3946 39.1557 18.2683 39.0857C18.142 39.0157 17.9996 38.9799 17.8552 38.982H7.22321L16.4122 30H11.1442C9.95321 30 8.81621 30.477 8.01821 31.254C6.81821 32.43 2.61521 36.927 1.98521 37.596C0.51821 39.159 -0.28879 40.404 0.0952104 41.943L1.77821 51.165C2.16221 52.707 3.85121 53.973 5.53421 53.973H54.4702C56.1532 53.973 57.8422 52.707 58.2262 51.165L59.9092 41.943C60.2872 40.404 59.4832 39.159 58.0132 37.596Z",
    fill: "#005596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReportFiles);
export default __webpack_public_path__ + "static/media/logo-report-files.10c1c813680c41f19f5f60213cbc43e4.svg";
export { ForwardRef as ReactComponent };